// extracted by mini-css-extract-plugin
export default {"item":"DndProductImage_item__git+Q","itemDragging":"DndProductImage_itemDragging__Eyexg","symbol":"DndProductImage_symbol__Wogwu","dragHandle":"DndProductImage_dragHandle__urZhc"};